//
//
//
//
//

export default {
  data() {
    return {
      select: this.value
    };
  },
  props: {
    list: {
      type: Array,
      default: []
    },
    value: {
      default: 0
    }
  },
  methods: {
    _handleClick(e) {
      this.$emit("update:value", e);
    }
  },
  watch: {
    value: function(e) {
      this.select = e;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/RadioSwitch.vue